import { Close as CloseIcon } from '@mui/icons-material';
import { Dialog, Stack, useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import DirectRequestForm, {
  DirectRequestFormPropTypes,
} from '@/components/DirectRequestForm/DirectRequestForm';
import Button from '@/components/ui/Button/Button';
import useFormatMessage from '@/hooks/useFormatMessage';

import { CloseButton, DialogContent } from './DirectRequestFormDialog.style';

const DirectRequestFormDialog = ({
  open,
  closeDialog,
  DirectRequestFormProps,
  'data-test-subject': dataTestSubject,
}) => {
  const smMediaQuery = useMediaQuery(theme => theme.breakpoints.down('sm'));

  const formatMessage = useFormatMessage();

  return (
    <Dialog
      open={open}
      onClose={closeDialog}
      scroll="body"
      fullWidth
      fullScreen={smMediaQuery}
      PaperProps={{
        'data-test-subject': dataTestSubject,
        sx: {
          ...(!smMediaQuery && { overflow: 'visible' }),
          maxWidth: { sm: 540 },
          paddingTop: 2,
        },
      }}>
      <CloseButton
        aria-label={formatMessage('hero_cancelModal')}
        onClick={closeDialog}
        size="small">
        <CloseIcon />
      </CloseButton>
      <DialogContent>
        <DirectRequestForm
          {...DirectRequestFormProps}
          closeDialog={closeDialog}
          showInfoText={false}
          onSubmit={() => {
            closeDialog();
            DirectRequestFormProps?.onSubmit?.();
          }}
          onRedirectWithItemsInBasket={() => {
            closeDialog();
            DirectRequestFormProps?.onRedirectWithItemsInBasket?.();
          }}
        />
        <Stack mt={2} alignItems="center">
          <Button
            size="large"
            color="primary"
            variant="text"
            onClick={closeDialog}
            fullWidth
            sx={{ maxWidth: { sm: 300 } }}>
            {formatMessage('hero_cancelModal')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

DirectRequestFormDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  DirectRequestFormProps: PropTypes.shape(DirectRequestFormPropTypes),
  'data-test-subject': PropTypes.string,
};

DirectRequestFormDialog.defaultProps = {
  'data-test-subject': 'direct-request-form-dialog',
};

export default DirectRequestFormDialog;
